<template>
    <div class="goods-add pb50">
        <el-form ref="form" size="small" :model="form" :rules="rules" label-width="100px">
            <div class="common-form">添加荣誉</div>
            <el-form-item label="荣誉名称" prop="honor_name">
                <el-input type="textarea" :rows="2" v-model="form.honor_name" placeholder="请输入荣誉名称" class="max-w460"></el-input>
            </el-form-item>
            <el-form-item label="简介" prop="honor_intro">
                <div class="edit_container">
                    <Uediter ref="ue" v-model="form.honor_intro" :text="ueditor.text" :config="ueditor.config"></Uediter>
                </div>
            </el-form-item>

            <el-form-item label="荣誉日期" prop="honor_date">
                <el-date-picker
                    v-model="form.honor_date"
                    type="date"
                    placeholder="选择日期"
                    class="max-w460"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="排序"><el-input v-model="form.sort" type="number" placeholder="请输入数字" class="max-w460"></el-input></el-form-item>
            <!--提交-->
            <div class="common-button-wrapper">
                <el-button size="small" type="info" :loading="loading" @click="cancelFunc">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="onSubmit">提交</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
    import PlatformActivityApi from "@/api/platformactivity.js";
    import Uediter from "@/components/UE.vue";

    export default {
        components: {
            /*编辑器*/
            Uediter,
        },
        data() {
            return {
                /*富文本框配置*/
                ueditor: {
                    text: "",
                    config: {
                        initialFrameWidth: 400,
                        initialFrameHeight: 500
                    }
                },
                /*form表单数据*/
                form: {
                    activity_honor_id:"",
                    activity_id:"",
                    honor_name:"",
                    honor_intro:"",
                    honor_date:"",
                    sort: 1,
                },
                loading: false,
                /*验证规则*/
                rules: {
                    activity_id: [{ required: true, message: "请选择活动", trigger: "blur" }],
                    honor_intro: [{ required: true, message: "请输入简介", trigger: "blur" }],
                }
            };
        },
        created() {
            this.form.activity_id = this.$route.query.activity_id;
        },
        methods: {
            /*添加广告*/
            onSubmit() {
                let self = this;
                let form = self.form;
                self.form.honor_intro = this.$refs.ue.getUEContent();
                self.$refs.form.validate((valid) => {
                    if (valid) {
                        self.loading = true;
                        PlatformActivityApi.honor.add(form, true)
                            .then((data) => {
                                self.loading = false;
                                self.$message({
                                    message: data.msg,
                                    type: "success"
                                });
                                self.$router.back()
                            })
                            .catch((error) => {
                                self.loading = false;
                            });
                    }
                });
            },

            /*取消添加，返回列表*/
            cancelFunc() {
                this.$router.back();
            }
        }
    };
</script>

<style>
    .edit_container {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    .ql-editor {
        height: 400px;
    }
</style>



// WEBPACK FOOTER //
// src/views/platformactivity/honor/add.vue